import React, { forwardRef, HTMLProps } from 'react';

import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';

import * as ST from './styled';

export interface IAdvertisingLabelProps extends Omit<HTMLProps<HTMLDivElement>, 'ref' | 'as'> {
    children?: React.ReactNode,
    onClick?: React.MouseEventHandler<HTMLDivElement>,
}

/**
 * Рекламная метка
 */
const AdvertisingLabel = forwardRef<HTMLDivElement, IAdvertisingLabelProps>(({
    children,
    onClick,
    ...props
}, ref): JSX.Element => {
    return (
        <ST.LabelContainer
            ref={ref}
            onClick={onClick}
            $radius={32}
            {...props}
        >
            <IndentContainer $united={[4, 8]}>
                <ST.Content>{children}</ST.Content>
            </IndentContainer>
        </ST.LabelContainer>
    );
});

AdvertisingLabel.displayName = 'LabelAdvertising';

export { AdvertisingLabel };
